import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components";

export const Wrap = styled.div`
  margin-top: 12px;
`;

export const ButtonWrap = styled.div`
  margin-top: 12px;
`;
